/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOpexDto } from '../../models/backend-opex-dto';

export interface SalesOpexsRetrieve$Params {
  /**
   * A unique integer value identifying this opex.
   */
  id: number;
}

export function salesOpexsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: SalesOpexsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendOpexDto>> {
  const rb = new RequestBuilder(rootUrl, salesOpexsRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendOpexDto>;
    }),
  );
}

salesOpexsRetrieve.PATH = '/api/sales/opexs/{id}/';
